import { ChatSharableInterface } from "./chat-sharable-interface";
import { User } from "./user";

export interface ExerciceData {
  id?: number;
  reference?: string;
  libraryId?: number;
  modelId?: number;
  name?: string;
  type?: string;
  exerciceType?: number;
  duration?: number;
  description?: string;
  tags?: string;
  video_url?: string;
  video_path?: string;
  video_thumbnail_path?: string;
  video_is_transcoded?: boolean;
  transcoding_started_at?: string;
  video?: any;
  image?: any;
  accent1?: number;
  accent2?: number;
  accent3?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;
  availableLangIds?: number[];
  libraryTag?: string;

  translations?: any;
  rights?: any;
  creater?: User;
}

export class Exercice implements ChatSharableInterface {
  public static readonly TYPE_REPEAT: number = 1;
  public static readonly TYPE_DURATION: number = 2;
  public static readonly TYPE_MODEL: string = 'MODEL';
  public static readonly TYPE_PLANNED: string = 'PLANNED';
  public static readonly TYPE_PERSONALIZED: string = 'PERSONALIZED';

  public static getNonTranslatableFields(): string[] { return ['id', 'reference', 'libraryId', 'modelId', 'type', 'exerciceType', 'duration', 'videoType', 'video_url', 'video_path', 'video_thumbnail_path', 'video_is_transcoded', 'transcoding_started_at', 'video', 'image', 'accent1', 'accent2', 'accent3', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getTranslatableFields(): string[] { return ['name', 'description', 'tags']; }
  public static getFields(): string[] { return ['id', 'reference', 'libraryId', 'modelId', 'name', 'type', 'exerciceType', 'duration', 'description', 'tags', 'videoType', 'video_url', 'video_path', 'video_thumbnail_path', 'video', 'image', 'accent1', 'accent2', 'accent3', 'createDate', 'createrId', 'updateDate', 'updaterId', 'deleteDate', 'deleterId']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  reference?: string;
  libraryId?: number;
  modelId?: number;
  name?: string;
  type?: string;
  exerciceType?: number;
  duration?: number;
  description?: string;
  tags?: string;
  video?: any;
  video_url?: string;
  video_path?: string;
  video_thumbnail_path?: string;
  video_is_transcoded?: boolean;
  transcoding_started_at?: string;
  image?: any;
  accent1?: number;
  accent2?: number;
  accent3?: number;
  createDate?: string;
  createrId?: number;
  updateDate?: string;
  updaterId?: number;
  deleteDate?: string;
  deleterId?: number;
  availableLangIds?: number[];
  libraryTag?: string;

  translations?: any;
  rights?: any;

  creater?: User;
  isVideoInProgress?: boolean;

  public static fromAPI(data: ExerciceData): Exercice {
    let translationData : any = {};
    for (let i = 0; i < data.translations?.length; i++) {
      if (data.translations[i]['exerciceId'] === data['id']) {
        translationData = data.translations[i];
        i = data.translations?.length;
      }
    }
    if (data.creater) {
      data.creater = User.fromAPI(data.creater);
    }
    return new Exercice({
      id: data.id,
      reference: data.reference,
      libraryId: data.libraryId,
      modelId: data.modelId,
      name: translationData.name ?? data.name,
      type: data.type,
      exerciceType: data.exerciceType,
      duration: data.duration,
      description: translationData.description ?? data.description,
      tags: translationData.tags ?? data.tags,
      video_url: data.video_url,
      video_path: data.video_path,
      video_thumbnail_path: data.video_thumbnail_path,
      video_is_transcoded: data.video_is_transcoded,
      transcoding_started_at: data.transcoding_started_at,
      image: data.image,
      accent1: data.accent1,
      accent2: data.accent2,
      accent3: data.accent3,
      createDate: data.createDate,
      createrId: data.createrId,
      updateDate: data.updateDate,
      updaterId: data.updaterId,
      deleteDate: data.deleteDate,
      deleterId: data.deleterId,
      availableLangIds: data.availableLangIds,
      libraryTag: data.libraryTag,

      translations: data.translations,
      rights: data.rights,

      creater: data.creater,
    });
  }

  public static fromAPIList(data: ExerciceData[], translationsData: any[]): Exercice[] {
    return data.map((item: ExerciceData) => Exercice.fromAPI(item));
  }

  constructor({id, reference, libraryId, modelId, name, type, exerciceType, duration, description, tags, video_url, video_path, video_thumbnail_path, video_is_transcoded, transcoding_started_at, image, accent1, accent2, accent3, createDate, createrId, updateDate, updaterId, deleteDate, deleterId, translations, rights, creater, availableLangIds, libraryTag} : ExerciceData) {
    this.id = id;
    this.reference = reference;
    this.libraryId = libraryId;
    this.modelId = modelId;
    this.name = name;
    this.type = type;
    this.exerciceType = exerciceType;
    this.duration = duration;
    this.description = description;
    this.tags = tags;
    this.video_url = video_url;
    this.video_path = video_path;
    this.video_thumbnail_path = video_thumbnail_path;
    this.video_is_transcoded = video_is_transcoded;
    this.transcoding_started_at = transcoding_started_at;
    this.image = image;
    this.accent1 = accent1;
    this.accent2 = accent2;
    this.accent3 = accent3;
    this.createDate = createDate;
    this.createrId = createrId;
    this.updateDate = updateDate;
    this.updaterId = updaterId;
    this.deleteDate = deleteDate;
    this.deleterId = deleterId;
    this.availableLangIds = availableLangIds,
    this.libraryTag = libraryTag;

    this.translations = translations;
    this.rights = rights;
    this.creater = creater;

    if (this.transcoding_started_at == null || this.video_is_transcoded) {
      this.isVideoInProgress = false;
    } 
    
    else {
      const threeMinutesAgo = Date.now() - (3 * 60 * 1000);
      this.isVideoInProgress = new Date(this.transcoding_started_at).getTime() >= threeMinutesAgo;  
    }
  }

  public toJson(): ExerciceData {
    return {
      id: this.id,
      reference: this.reference,
      libraryId: this.libraryId,
      modelId: this.modelId,
      name: this.name,
      type: this.type,
      exerciceType: this.exerciceType,
      duration: this.duration,
      description: this.description,
      tags: this.tags,
      video_url: this.video_url,
      video_path: this.video_path,
      video_thumbnail_path: this.video_thumbnail_path,
      video_is_transcoded: this.video_is_transcoded,
      transcoding_started_at: this.transcoding_started_at,
      image: this.image,
      accent1: this.accent1,
      accent2: this.accent2,
      accent3: this.accent3,
      createDate: this.createDate,
      createrId: this.createrId,
      updateDate: this.updateDate,
      updaterId: this.updaterId,
      deleteDate: this.deleteDate,
      deleterId: this.deleterId,
      availableLangIds: this.availableLangIds,
      libraryTag: this.libraryTag,
    };
  }

  chatSharableId(): number {
    return this.id ?? 0;
  }

  chatSharableName(): string {
    return this.name ?? '';
  }

  chatSharableType(): string {
    return "exercise";
  }

  /**
   * Checks if the video is currently being transcoded.
   * Returns true if transcoding started within the last 3 minutes and is not yet complete.
   */
  public isVideoBeingTranscoded(): boolean {
    return this.isVideoInProgress ?? false;
  }
}
